import { Trans, useLingui } from "@lingui/react/macro";
import type { Bot, RunActivityRow } from "@rakazo/contracts";
import { Button, Input } from "@rakazo/ui-web";
import { SlidersHorizontal } from "lucide-react";
import { useId, useState } from "react";
import { emptyActivityFilters } from "../../lib/activity-list-filters";
import { ActivityList } from "../ActivityList";

export function BotActivity({
  bot,
  onOpenRun,
}: {
  bot: Bot;
  onOpenRun: (run: RunActivityRow) => void;
}) {
  const { t } = useLingui();
  const [filters, setFilters] = useState(emptyActivityFilters);
  const [expanded, setExpanded] = useState(false);
  const filtersId = useId();
  return (
    <section
      aria-label={t`${bot.name} activity`}
      className="space-y-4"
      data-testid="bot-activity-panel"
    >
      <h2 className="text-base font-semibold">
        {bot.name} · <Trans>Activity</Trans>
      </h2>
      <div className="flex items-center gap-2">
        <Input
          aria-label={t`Search activity`}
          placeholder={t`Search activity`}
          value={filters.query}
          onChange={(event) => setFilters({ ...filters, query: event.target.value })}
        />
        <Button
          variant="ghost"
          size="icon-sm"
          aria-label={t`Filters`}
          aria-expanded={expanded}
          aria-controls={filtersId}
          onClick={() => setExpanded((value) => !value)}
        >
          <SlidersHorizontal size={16} />
        </Button>
      </div>
      <ActivityList
        botId={bot.id}
        filters={filters}
        onFiltersChange={setFilters}
        filtersExpanded={expanded}
        filtersId={filtersId}
        onOpenRun={onOpenRun}
      />
    </section>
  );
}
